import styled from 'styled-components';
import { FlexibleDiv } from '../../styled/common';

export const AdditionalParametersWrapper = styled(FlexibleDiv)`
  gap: 10px;
  flex-wrap: wrap;
`;
